/**
 * Polyfill for File class in Node.js environment
 * Required for Chakra UI v3 / @zag-js/floating-panel SSR compatibility
 */

if (typeof File === "undefined") {
  // @ts-expect-error - polyfilling global File for SSR
  global.File = class File extends Blob {
    name: string;
    lastModified: number;

    constructor(
      chunks: BlobPart[],
      filename: string,
      options?: FilePropertyBag
    ) {
      super(chunks, options);
      this.name = filename;
      this.lastModified = options?.lastModified ?? Date.now();
    }
  };
}

export {};
